import type { OutreachEmailSource } from '@discovr/types';

/** Where an address came from, in words — one label per BE ContactSource. */
const EMAIL_SOURCE_LABEL: Record<OutreachEmailSource | 'sheet_import' | 'paste_import', string> = {
  sheet_import: 'From the sheet import',
  paste_import: 'From pasted handles',
  manual: 'Added manually',
  phyllo_verified: 'Verified via Phyllo',
  phyllo: 'From Phyllo',
  extracted: 'Extracted from bio',
  bio: 'Found in bio',
  link: 'From their link page',
  deobfuscated: 'De-obfuscated from bio',
  apify: 'From Apify scrape',
};

/** A source a newer backend sends that this build doesn't know shows by its raw name. */
export function sourceLabel(source: string): string {
  return (EMAIL_SOURCE_LABEL as Partial<Record<string, string>>)[source] ?? source;
}
